/* ==========================================================================
   Nickname-Druck

   Zwei Aufgaben:

   1. Den getippten Namen über den Neuaufbau retten. Prestige lädt den Produktbereich
      bei jedem Varianten­wechsel neu vom Server – das Feld kommt dabei leer zurück.
      Genau daran ist die frühere App-Lösung gescheitert.

   2. Den Aufpreis ergänzen. Shopify kann keinen Betrag auf eine bestehende Zeile
      aufschlagen, deshalb wandert das Produkt "Nickname-Druck" als eigene Position
      mit – in derselben Menge wie das Teil, denn der Aufpreis gilt pro Stück.
      Dafür übernimmt dieses Skript das Absenden des Formulars und legt beide
      Positionen in einem Zug in den Warenkorb.
   ========================================================================== */

(() => {
  const DRUCK_HANDLE = 'nickname-druck';

  // Überlebt den Neuaufbau, weil es außerhalb des ersetzten DOM liegt
  const gemerkt = new Map();

  const formularVon = (wurzel) => document.getElementById(wurzel.dataset.form);

  const schluessel = (wurzel) => wurzel.dataset.form || 'nickname';

  function verdrahten(wurzel) {
    if (wurzel.dataset.bereit === '1') return;
    wurzel.dataset.bereit = '1';

    const schalter = wurzel.querySelector('[data-nickname-toggle]');
    const koerper = wurzel.querySelector('[data-nickname-body]');
    const feld = wurzel.querySelector('[data-nickname-input]');
    if (!schalter || !koerper || !feld) return;

    const stand = gemerkt.get(schluessel(wurzel));
    if (stand) {
      schalter.checked = stand.an;
      feld.value = stand.name;
    }

    /**
     * Express-Knoepfe (PayPal, Shop Pay und Co.) erzeugen den Checkout direkt aus
     * dem Produktformular und gehen am Warenkorb vorbei. Der Aufpreis entsteht aber
     * erst im Warenkorb – ueber diesen Weg bestellt, reist der Name also mit, der
     * Betrag nicht. Nachweis: Bestellung #1058. Deshalb sind diese Knoepfe bei
     * gesetztem Haken ausgeblendet; ohne Nickname bleiben sie unveraendert.
     */
    const expressUmschalten = (an) => {
      const id = wurzel.dataset.form;
      if (!id) return;
      document.querySelectorAll('buy-buttons[form="' + id + '"]').forEach((knopfleiste) => {
        knopfleiste.classList.toggle('buy-buttons--ohne-express', an);
      });
    };

    const anwenden = () => {
      koerper.hidden = !schalter.checked;
      // Deaktivierte Felder werden nicht mitgesendet – so landet keine leere
      // Eigenschaft an der Position, wenn niemand einen Namen will.
      feld.disabled = !schalter.checked;
      feld.required = schalter.checked;
      expressUmschalten(schalter.checked);
      gemerkt.set(schluessel(wurzel), { an: schalter.checked, name: feld.value });
    };

    schalter.addEventListener('change', anwenden);
    feld.addEventListener('input', () => {
      gemerkt.set(schluessel(wurzel), { an: schalter.checked, name: feld.value });
    });
    anwenden();

    const formular = formularVon(wurzel);
    if (formular && formular.dataset.nicknameGebunden !== '1') {
      formular.dataset.nicknameGebunden = '1';
      formular.addEventListener('submit', (e) => absenden(e, formular, wurzel), true);
    }
  }

  /**
   * Übernimmt das Absenden, sobald ein Name eingetragen ist: beide Positionen in einem
   * Zug, danach dieselben Ereignisse wie das Theme, damit Warenkorb und Schieber
   * sich normal aktualisieren. Ohne Namen bleibt alles beim Theme.
   */
  async function absenden(event, formular, wurzel) {
    const feld = wurzel.querySelector('[data-nickname-input]');
    const name = feld && !feld.disabled ? feld.value.trim() : '';
    if (!name) return;

    event.preventDefault();
    event.stopImmediatePropagation();

    if (!formular.checkValidity()) {
      formular.reportValidity();
      return;
    }

    const knoepfe = Array.from(formular.elements).filter((e) => e.type === 'submit');
    knoepfe.forEach((k) => k.setAttribute('aria-busy', 'true'));
    document.documentElement.dispatchEvent(new CustomEvent('theme:loading:start', { bubbles: true }));

    const wurzelPfad = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    // Menge und Variante aus den Formulardaten lesen: Prestige haengt die Mengenauswahl
    // ueber das form-Attribut an, sie steht aber ausserhalb des <form> im DOM.
    const formDaten = new FormData(formular);
    const menge = Number(formDaten.get('quantity') || 1) || 1;
    const teilId = formDaten.get('id');

    const abschnitte = [];
    document.documentElement.dispatchEvent(
      new CustomEvent('cart:prepare-bundled-sections', { bubbles: true, detail: { sections: abschnitte } })
    );

    try {
      const antwort = await fetch(`${wurzelPfad}cart/add.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({
          items: [
            { id: Number(teilId), quantity: menge, properties: { Nickname: name } },
            { id: Number(wurzel.dataset.variant), quantity: menge, properties: { Nickname: name } },
          ],
          sections: abschnitte.join(','),
        }),
      });

      const daten = await antwort.json();
      knoepfe.forEach((k) => k.removeAttribute('aria-busy'));
      document.documentElement.dispatchEvent(new CustomEvent('theme:loading:end', { bubbles: true }));

      // Auch bei 422 weitermachen: Shopify kappt die Menge am Bestand, meldet den Fehler,
      // legt die Position aber trotzdem an. Ein Abbruch hier hinterliesse einen Warenkorb,
      // in dem mehr Aufpreise als Teile stehen.
      await abgleichen(true);

      const einstellungen = window.themeVariables && window.themeVariables.settings;
      if (einstellungen && (einstellungen.cartType === 'page' || einstellungen.pageType === 'cart')) {
        window.location.href = `${wurzelPfad}cart`;
        return;
      }

      // Den Warenkorb samt vorgerenderter Seitenteile holen. Bei gekappter Menge liefert
      // cart/add.js keine Seitenteile mit – ohne sie stolpert der Warenkorb-Schieber.
      const abschnitteNachher = [];
      document.documentElement.dispatchEvent(
        new CustomEvent('cart:prepare-bundled-sections', { bubbles: true, detail: { sections: abschnitteNachher } })
      );
      const frisch = await fetch(`${wurzelPfad}cart/update.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ attributes: {}, sections: abschnitteNachher.join(',') }),
      });
      const warenkorb = await frisch.json();
      if (!warenkorb.sections) warenkorb.sections = daten.sections;

      formular.dispatchEvent(new CustomEvent('variant:add', {
        bubbles: true,
        detail: { items: daten.items || [daten], cart: warenkorb, onSuccessDo: formDaten.get('on_success') },
      }));
      if (warenkorb.sections) {
        document.documentElement.dispatchEvent(new CustomEvent('cart:change', {
          bubbles: true,
          detail: { baseEvent: 'variant:add', cart: warenkorb },
        }));
      } else {
        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
      }
    } catch (_) {
      knoepfe.forEach((k) => k.removeAttribute('aria-busy'));
      document.documentElement.dispatchEvent(new CustomEvent('theme:loading:end', { bubbles: true }));
    }
  }

  /**
   * Haelt die Aufpreis-Positionen mit den bedruckten Teilen im Gleichgewicht.
   *
   * Noetig, weil Shopify die Menge eines Teils am Lagerbestand kappen kann: Wer drei
   * Shirts bestellt, von denen nur zwei da sind, bekommt zwei Shirts – der Aufpreis ist
   * aber nicht bestandsgefuehrt und liefe sonst auf drei. Ebenso, wenn jemand die Menge
   * spaeter im Warenkorb aendert. Gezaehlt wird je Nickname getrennt.
   */
  let laeuft = false;
  async function abgleichen(stillBleiben = false) {
    if (laeuft) return;
    laeuft = true;
    try {
      const wurzelPfad = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      const warenkorb = await (await fetch(`${wurzelPfad}cart.js`)).json();
      const soll = new Map();
      warenkorb.items.forEach((zeile) => {
        const name = zeile.properties && zeile.properties.Nickname;
        if (!name || zeile.handle === DRUCK_HANDLE) return;
        soll.set(name, (soll.get(name) || 0) + zeile.quantity);
      });

      let geaendert = null;
      for (const zeile of warenkorb.items) {
        if (zeile.handle !== DRUCK_HANDLE) continue;
        const name = zeile.properties && zeile.properties.Nickname;
        const gewuenscht = name ? soll.get(name) || 0 : 0;
        if (gewuenscht === zeile.quantity) continue;

        const abschnitte = [];
        document.documentElement.dispatchEvent(
          new CustomEvent('cart:prepare-bundled-sections', { bubbles: true, detail: { sections: abschnitte } })
        );
        const antwort = await fetch(`${wurzelPfad}cart/change.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: zeile.key, quantity: gewuenscht, sections: abschnitte.join(',') }),
        });
        if (antwort.ok) geaendert = await antwort.json();
      }

      // Nur wenn wirklich korrigiert wurde, die Oberfläche nachziehen. Die dadurch
      // ausgelöste Meldung findet beim nächsten Durchlauf nichts mehr zu tun.
      if (geaendert && !stillBleiben) {
        // Siehe assets/affiliate-gift.js: auf der Warenkorbseite neu laden
        if (window.location.pathname.replace(/\/+$/, '').endsWith('/cart')) {
          window.location.reload();
          return geaendert;
        }
        if (geaendert.sections) {
          document.documentElement.dispatchEvent(new CustomEvent('cart:change', {
            bubbles: true,
            detail: { baseEvent: 'line-item:change', cart: geaendert },
          }));
        } else {
          document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        }
      }
      return geaendert;
    } catch (_) {
      // Stilles Scheitern ist hier richtig: lieber ein unveraenderter Warenkorb als ein Fehler
    } finally {
      laeuft = false;
    }
  }

  const alleVerdrahten = () => document.querySelectorAll('[data-nickname]').forEach(verdrahten);

  alleVerdrahten();
  document.addEventListener('DOMContentLoaded', alleVerdrahten);
  // Nach dem Neuaufbau durch das Theme steht ein frisches Feld da – neu verdrahten
  // und den gemerkten Namen wieder eintragen.
  document.addEventListener('variant:change', () => setTimeout(alleVerdrahten, 0), true);
  document.addEventListener('product:rerender', () => setTimeout(alleVerdrahten, 0), true);

  // Mengenaenderungen im Warenkorb oder Schieber nachziehen. Der Abgleich aendert nur,
  // wenn etwas nicht passt – die dadurch ausgeloeste Meldung findet nichts mehr zu tun.
  document.addEventListener('cart:change', () => { setTimeout(abgleichen, 0); });
})();
